var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60922 6.25421C8.95635 6.59315 8.95635 7.14269 8.60922 7.48164L5.51743 10.5005C5.1703 10.8395 4.60748 10.8395 4.26035 10.5005C3.91322 10.1616 3.91322 9.61202 4.26035 9.27308L7.35214 6.25421C7.69927 5.91526 8.26208 5.91526 8.60922 6.25421Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26035 9.27308C4.60748 8.93413 5.1703 8.93413 5.51743 9.27308L8.60922 12.2919C8.95635 12.6309 8.95635 13.1804 8.60922 13.5194C8.26208 13.8583 7.69927 13.8583 7.35214 13.5194L4.26035 10.5005C3.91322 10.1616 3.91322 9.61202 4.26035 9.27308Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.88679C4 9.40745 4.39797 9.01887 4.88889 9.01887H15.401C17.9386 9.01887 20 11.0316 20 13.5094C20 15.9873 17.9386 18 15.401 18H11.6908C11.1999 18 10.8019 17.6114 10.8019 17.1321C10.8019 16.6527 11.1999 16.2642 11.6908 16.2642H15.401C16.9568 16.2642 18.2222 15.0286 18.2222 13.5094C18.2222 11.9903 16.9568 10.7547 15.401 10.7547H4.88889C4.39797 10.7547 4 10.3661 4 9.88679Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBack);
export default __webpack_public_path__ + "static/media/line-back.6728165c346b0758ddee3bb6db0991e8.svg";
export { ForwardRef as ReactComponent };